import React, { memo } from 'react';
import { Clock } from 'lucide-react';

import styles from '../styles/AgentSettings.module.css';

const AgentFilesTab = () => {
    return (
        <div className={styles.tabContent}>
            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>
                    File Management
                </h3>
                <p className={styles.sectionDescription}>
                    Upload and manage files that your agent can reference and use as knowledge base.
                </p>

                <div className={styles.comingSoon}>
                    <Clock size={18} className={styles.comingSoonIcon} />
                    <p className={styles.comingSoonText}>
                        This feature is currently in development and will be available soon.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default memo(AgentFilesTab);
